// src/components/AuthManagement/AdminRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

interface AdminRouteProps {
  redirectPath?: string;
}

/**
 * AdminRoute - Protects routes that should only be accessible to admin users.
 * Checks if user is logged in AND has is_admin flag set to true.
 */
export const AdminRoute: React.FC<AdminRouteProps> = ({ 
  redirectPath = '/login' 
}) => {
  const { loggedIn, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner text="Verificando permisos..." />;
  }

  // Check if user is logged in
  if (!loggedIn) {
    return <Navigate to={redirectPath} />;
  }

  // Check if user is admin
  const userJson = localStorage.getItem('user');
  if (userJson) {
    const user = JSON.parse(userJson);
    if (user.is_admin === true) {
      return <Outlet />;
    }
  }

  // Not admin - redirect to main app
  return <Navigate to="/App" />;
};

export default AdminRoute;
